<template>
  <div v-if="isOpen" class="modal-container">
    <div class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"></div>
    <div class="modal-content w-[550px] relative bg-white w-full max-w-md m-auto flex-col flex rounded-lg z-50">
      <div class="w-full border-b-[1px] mb-4 px-6 py-4">
        <h2 class="text-[18px] text-grayDark">
          Are you sure you want to remove <span class="font-bold">{{ selectedContributor.name }}</span> from this project?
        </h2>
      </div>

      <form @submit.prevent="removeContributor" class="overflow-y-auto px-6">
        <div class="mb-4">
          <p class="text-sm text-gray-600 mb-4">
            This action will remove the contributor from the project. They will no longer have access to project resources.
          </p>
          <label class="block text-sm font-medium text-gray-700">
            To confirm, type "remove" in the box below
          </label>
          <input
            type="text"
            v-model="confirmationText"
            placeholder="Type remove"
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            required
          />
        </div>
        <div class="flex justify-end gap-4 mb-4">
          <button 
            type="button" 
            class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded" 
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            type="submit"
            :class="[
              'py-2 px-4 w-[146px] h-[42px] text-white rounded',
              confirmationText === 'remove' ? 'bg-red-500 hover:bg-red-600' : 'bg-gray-300 cursor-not-allowed'
            ]"
            :disabled="confirmationText !== 'remove'"
          >
            Remove contributor
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "RemoveContributorModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    selectedContributor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      confirmationText: "",
    };
  },
  methods: {
    removeContributor() {
      if (this.confirmationText === 'remove') {
        this.$emit('confirm-remove', this.selectedContributor.id);
        this.confirmationText = '';
      }
    },
  },
  watch: {
    isOpen(newVal) {
      if (!newVal) {
        this.confirmationText = '';
      }
    },
  },
};
</script>

<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 60;
}

.modal-content {
  max-height: 90vh;
  overflow-y: auto;
  margin: 20px;
  z-index: 70;
}
</style>
